import * as Yup from 'yup';
import { FC, useEffect, useState } from 'react';
import { useFormik } from 'formik';
import {
  Container,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Button,
  Typography,
  Autocomplete
} from '@mui/material';
import TextField from '@mui/material/TextField';
import request from '../../../../utils/request';
import { LoadingButton } from '@mui/lab';
import SnackbarAlert from '../../../common/SnackbarAlert';
import React from 'react';
import AutocompleteLoader from '../../../common/AutocompleteLoader';
type CreateEditProps = {
  closeCreateEditForm: any;
  othersEditDatas: any;
  editStatus: boolean;
  productId: any;
  setNewValue?: Function;
};
const CreateEdit: FC<CreateEditProps> = ({
  closeCreateEditForm,
  othersEditDatas,
  editStatus,
  productId,
  setNewValue
}) => {
  const OthersSchema = Yup.object().shape({
    name: Yup.string()
      .required('Name is required')
      .min(3, 'Name must be at least 3 characters'),
      // .test(
      //   'notOnlyWhiteSpace',
      //   'Name cannot include leading and trailing spaces',
      //   (value) => {
      //     return !/\s{2,}/.test(value);
      //   }
      // )
      // .matches(
      //   // eslint-disable-next-line no-useless-escape
      //   /^[a-zA-Z0-9\s\[\]\-\(\)&\/\\<>]*$/,
      //   'Name only accepts special characters like &,[,],-,/,(,),<,>'
      // )
      // .matches(
      //   /[a-zA-Z]/,
      //   'Name must include at least one letter of the alphabet'
      // ),
    // .test(
    //   'notOnlyWhiteSpace',
    //   'Name cannot include leading and trailing spaces',
    //   (value) => {
    //     return !/\s{2,}/.test(value);
    //   }
    // ),
    code: Yup.string()
      .required('Code is required')
      // .test(
      //   'notOnlyWhiteSpace',
      //   'Code cannot include leading and trailing spaces',
      //   (value) => {
      //     return !/\s{2,}/.test(value);
      //   }
      // )
      .min(2, 'Code must be at least 2 characters'),
      // .matches(
      //   // eslint-disable-next-line no-useless-escape
      //   /^[a-zA-Z0-9\s\[\]\-\(\)&\/\\]*$/,
      //   'Code only accepts special characters like &,[,],-,/,(,)'
      // ),
    // .matches(
    //   /[a-zA-Z]/,
    //   'Code must include at least one letter of the alphabet'
    // ),
    rate: Yup.number()
      .notRequired()
      .typeError('Rate is not valid')
      .positive('Must be a positive number.')
      .min(1, 'Rate must be greater than or equal to 1')
      .transform((value, originalValue) => {
        return /\s/.test(originalValue) ? NaN : value;
      })
      .test('len', 'Length is too long', (val) => {
        if (val === undefined || val === null) return true;
        const valStr = val.toString();
        const maxLength = valStr.includes('.') ? 10 : 8;
        return valStr.length <= maxLength;
      })
      .test(
        'max-two-decimals',
        'Rate must have at most two decimal places',
        (value) => {
          if (value === undefined || value === null) return true;
          const decimalPlaces = value.toString().split('.')[1];
          return !decimalPlaces || decimalPlaces.length <= 2;
        }
      )
      .nullable()
    // productId: Yup.number().required('Product is required')
  });
  const [isLoading, setLoading] = useState<boolean>(true);
  const [loader, setLoader] = useState<boolean>(false);
  const [showSnackBarAlert, setShowSnackBarAlert] = useState<{
    status: boolean;
    type: string;
    message: any;
  }>({
    status: false,
    type: 'success',
    message: null
  });
  const [productData, setProductData] = useState<any>([]);
  const [productSearchValue, setProductSearchValue] = useState<string>('');
  const [productValue, setProductValue] = useState<any>(null);
  const formik = useFormik({
    initialValues: {
      id: '',
      name: '',
      code: '',
      rate: '',
      status: true,
      productId: productId
    },
    validationSchema: OthersSchema,
    onSubmit: (values) => {
      //values.productId=product.id
      console.log(values);
      setLoader(true);
      const method = editStatus ? 'PUT' : 'POST';
      request({
        url: 'others-settings',
        method: method,
        data: values
      })
        .then((others) => {
          if (others.status) {
            closeCreateEditForm(true);
            setLoader(false);
            if (setNewValue) {
              setNewValue(values?.name);
            }
          } else {
            setLoader(false);
            setShowSnackBarAlert({
              status: true,
              type: 'error',
              message: others['message']
            });
          }
        })
        .catch(function (err) {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: err.message
          });
          setLoader(false);
        });
    }
  });
  useEffect(() => {
    fetchProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productSearchValue]);
  const fetchProducts = async () => {
    request({
      url: 'policyProduct/getPolicyProductList',
      method: 'post',
      data: {
        search: productSearchValue,
        orderColumn: 'id',
        orderDirection: 'DESC',
        offset: 0,
        limit: 100,
        status: true
      }
    }).then(
      (response) => {
        setProductData(response['policyProductData']);
        setLoading(false);
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    if (editStatus) {
      fetchPolicyProductNameById();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const fetchPolicyProductNameById = async () => {
    request({
      url: 'policyProduct/getPolicyProductNameById',
      method: 'post',
      data: {
        id: othersEditDatas?.productId
      }
    }).then(
      (response: any) => {
        formik.setValues((prev) => ({
          ...prev,
          productId: response?.id
        }));
        setProductSearchValue(response?.name);
        setLoading(false);
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );
  };
  const capitalizeFirst = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  if (editStatus) {
    formik.values.id = othersEditDatas.id;
    formik.initialValues.name = othersEditDatas.name;
    formik.initialValues.code = othersEditDatas.code;
    formik.initialValues.rate = othersEditDatas.rate;
  }
  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  return (
    <>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <Card>
              {editStatus ? (
                <CardHeader title="Update Others" />
              ) : (
                <CardHeader title="Create Others" />
              )}
              <Divider />

              <CardContent>
                <form onSubmit={formik.handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label={
                          <React.Fragment>
                            Name{' '}
                            <Typography component="span" sx={{ color: 'red' }}>
                              *
                            </Typography>
                          </React.Fragment>
                        }
                        sx={{ width: '100%' }}
                        size="small"
                        name="name"
                        value={capitalizeFirst(formik.values.name)}
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          const trimmedValue = e.target.value.trim();
                          formik.setFieldValue('name', trimmedValue);
                          formik.handleBlur(e);
                        }}
                        error={
                          formik.touched.name && Boolean(formik.errors.name)
                        }
                        helperText={formik.touched.name && formik.errors.name}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        label={
                          <React.Fragment>
                            Code{' '}
                            <Typography component="span" sx={{ color: 'red' }}>
                              *
                            </Typography>
                          </React.Fragment>
                        }
                        sx={{ width: '100%' }}
                        size="small"
                        name="code"
                        value={formik.values.code}
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          const trimmedValue = e.target.value.trim();
                          formik.setFieldValue('code', trimmedValue);
                          formik.handleBlur(e);
                        }}
                        error={
                          formik.touched.code && Boolean(formik.errors.code)
                        }
                        helperText={formik.touched.code && formik.errors.code}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        label={<React.Fragment>Rate </React.Fragment>}
                        sx={{ width: '100%' }}
                        size="small"
                        name="rate"
                        type="number"
                        onKeyDown={(e) => {
                          if (['e', 'E', '-', '+'].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        value={formik.values.rate}
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          const formattedValue = e.target.value?.includes('.')
                            ? e.target.value.replace(
                                /(\.\d*?[1-9])0+$|\.0*$/,
                                '$1'
                              )
                            : e.target.value;
                          formik.setFieldValue('rate', formattedValue, true);
                          formik.handleBlur(e);
                        }}
                        error={
                          formik.touched.rate && Boolean(formik.errors.rate)
                        }
                        helperText={formik.touched.rate && formik.errors.rate}
                      />
                    </Grid>

                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      spacing={3}
                      mt={2}
                    >
                      {loader ? (
                        <LoadingButton
                          sx={{ mt: { xs: 2, md: 0 } }}
                          loading={loader}
                          variant="contained"
                          type="submit"
                        >
                          Save
                        </LoadingButton>
                      ) : (
                        <Button
                          sx={{ mt: { xs: 2, md: 0 } }}
                          type="submit"
                          variant="contained"
                        >
                          Save
                        </Button>
                      )}
                      &nbsp;
                      <Button
                        sx={{ mt: { xs: 2, md: 0 } }}
                        variant="contained"
                        color="error"
                        onClick={closeCreateEditForm}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default CreateEdit;
